import {ApplicationRole, Role} from "@/services/models/Role";
import store from "../store";
import {ToastType} from "@/services/models/shared/ToastType";
import Vue from "vue";

export default Vue.mixin({
    computed:{
        applicationRoles():ApplicationRole[]{
            return store.getters.user?.roles ?? [];
        }
    },
    methods: {
        hasApplicationRole(...roles: ApplicationRole[]): boolean {
            // Admin role has full access
            const isAdministrator: boolean = !store.getters.user ? false : store.getters.user.roles.find((r: Role) => r.id.toUpperCase() == ApplicationRole.Administrator);
            const hasRole: boolean = !store.getters.user ? false : store.getters.user.roles.some((r: Role) => roles.indexOf(r.id.toUpperCase() as ApplicationRole) >= 0);

            return isAdministrator || hasRole;
        },

        redirectToError(message) {
            this.$router.replace({
                name: 'Error', params: {
                    errorMessage: message
                }
            })
        },

        /**
         * Creates an alert message toast
         * @param type The toast type variant
         * @param message The toast message content
         */
        alert(type: ToastType, message: string) {

            let options = {};

            switch (type) {
                case ToastType.Success:
                    options = {
                        title: 'Success',
                        variant: 'success',
                    };
                    break;
                case ToastType.Information:
                    options = {
                        title: 'Information',
                        variant: 'info',
                    };
                    break;
                case ToastType.Warning:
                    options = {
                        title: 'Warning',
                        variant: 'warning',
                    };
                    break;
                case ToastType.Danger:
                    options = {
                        title: 'Error',
                        variant: 'danger',
                    };
                    break;
                default:
                    options = {
                        title: '',
                        variant: 'default',
                    };
            }

            // Set tot he toast on the root to avoid issues with routing
            this.$root.$bvToast.toast(message, {
                ...options,
                toaster: "b-toaster-top-right",
                autoHideDelay: 5000,
                toastClass: null,
                headerClass: null,
                bodyClass: null,
            });
        }
    }
});
